module.exports = __webpack_public_path__ + "static/img/bg_prizepool.257b252.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/bg_prizepool.png
// module id = XhgK
// module chunks = 1